import React, { useEffect, useState } from 'react';
import { Form, InputGroup, Spinner, Modal, Card } from 'react-bootstrap';
import { Button, ButtonGroup, Row, Col, CardBody } from 'reactstrap';
import Axios from 'axios';
import { useHistory } from 'react-router-dom';
import { Backspace, Save2Fill, Star } from 'react-bootstrap-icons';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import * as Yup from 'yup';
import { Field, Formik } from 'formik';

import dateformat from 'dateformat';

import common from '../../commonData';
import { ProductList, Summary } from './cardadd';

function FactureMultiple({ setShowFact, show, setIsSave, setMsg, setMsgravity, selectedRows, actualise, setActualise }) {
    var ladate = new Date();
    // console.log(selectedRows);
    const [codeart, setCodeart] = useState([]);
    const [fournisseur, setDataFrs] = useState([]);
    const [load, setLoad] = useState(false);
    const history = useHistory();
    const [listeSelect, setListeSelect] = useState([]);

    const [states, setState] = useState({
        datefacture: dateformat(ladate.getMonth() + 1 + '/' + ladate.getDate() + '/' + ladate.getFullYear(), 'yyyy-mm-dd'),
        nofact: '',
        fournisseur_id: '',
        sitva: '0'
    });
    const { datefacture, nofact, fournisseur_id, sitva } = states;
    useEffect(() => {
        if (!localStorage.getItem('user-info')) {
            history.push('/login');
        }
        (async function anyNameFunction() {
            setLoad(true);
            const getCli = Axios.get(common.ipapi + '/api/fournisseur/all');
            const getLigne = Axios.get(common.ipapi + '/api/entreligne/get/' + selectedRows);
            await Axios.all([getLigne, getCli])
                .then(
                    Axios.spread((...response) => {
                        var t = [];
                        setDataFrs(response[1].data || []);
                        response[0].data.datas.forEach((element) => {
                            if (element.facture_id > 0) {
                                setIsSave(true);
                                setMsgravity('danger');
                                setMsg('Veuillez saisir des BLs non facturés');
                                setShowFact(false);

                                return false;
                            }

                            if (response[0].data.datas[0].fournisseur_id !== element.fournisseur_id) {
                                setIsSave(true);
                                setMsgravity('warning');
                                setMsg('Les BLs sélectionnés doivent appartenir au même fournisseur');
                                setShowFact(false);
                                return false;
                            }
                            element.ligneentree.forEach((elt) => {
                                t.push({
                                    id: elt.id,
                                    codeentre: element.codeentre,
                                    qrbarre: elt.qrbarre,
                                    descriptionart: elt.descriptionart,
                                    quantite: elt.pivot.quantite,
                                    remise: elt.pivot.remise,
                                    prix: elt.pivot.prixachat
                                });
                            });
                        });
                        setState({
                            fournisseur_id: response[0].data.datas[0].fournisseur_id,
                            sitva: response[0].data.datas[0].sitva
                        });
                        setCodeart(selectedRows);
                        t.sort(GetSortOrder('id'));
                        setListeSelect(t);
                        setLoad(false);
                    })
                )
                .catch((errors) => {
                    setLoad(false);
                });
        })();
    }, [history]);

    function GetSortOrder(prop) {
        return function (a, b) {
            if (a[prop] < b[prop]) {
                return 1;
            } else if (a[prop] > b[prop]) {
                return -1;
            }
            return 0;
        };
    }
    function groupBy(tableauObjets) {
        var result = [];
        var ind = 0;
        var prixvente = 0;
        var prixachat = 0;
        var remise = 0;
        return tableauObjets.reduce(function (res, value) {
            ind++;
            prixvente += value.prix;
            prixachat += value.prixachat;
            remise += value.remise;
            if (!res[value.id]) {
                res[value.id] = {
                    id: value.id,
                    quantite: 0,
                    prix: 0,
                    descriptionart: value.descriptionart,
                    remise: 0,
                    prixachat: 0,
                    prixventes: 0
                };
                result.push(res[value.id]);
                ind = 1;
                prixvente = value.prix;
                prixachat = value.prixachat;
                remise = value.remise;
            }
            res[value.id].prixventes += value.quantite * value.prix;
            res[value.id].quantite += value.quantite;
            res[value.id].prix = res[value.id].prixventes / res[value.id].quantite; ///prixvente / ind;
            res[value.id].prixachat = prixachat / ind;
            res[value.id].remise = remise / ind;
            return res;
        }, {});
    }
    const subTotal = listeSelect.reduce((total, product) => {
        return total + (product.quantite * product.prix - product.quantite * product.prix * (product.remise / 100));
    }, 0);
    const onChangeProductQuantity = (index, event) => {
        const cloneProducts = [...listeSelect];
        cloneProducts[index].quantite = event.target.value;
        setListeSelect(cloneProducts);
    };

    const onChangePrestation = (index, event) => {
        const value = event.target.value;
        const cloneProducts = [...listeSelect];
        cloneProducts[index].descriptionart = value;
        setListeSelect(cloneProducts);
    };

    const onChangeRemise = (index, event) => {
        const value = event.target.value;
        const cloneProducts = [...listeSelect];
        cloneProducts[index].remise = value;

        setListeSelect(cloneProducts);
    };

    const onChangePrix = (index, event) => {
        const value = event.target.value;
        const valueInt = parseInt(value);
        const cloneProducts = [...listeSelect];
        cloneProducts[index].prix = valueInt;

        setListeSelect(cloneProducts);
    };

    const onRemoveProduct = (i, id) => {
        var filteredProduct = [];
        setLoad(true);
        filteredProduct = listeSelect.filter((product, index) => {
            return index !== i;
        });
        setListeSelect(filteredProduct);
        setMsg('Ligne supprimée');
        setMsgravity('info');
        setIsSave(true);
        setLoad(false);
    };

    const handleClose = () => {
        setShowFact(false);
        setIsSave(false);
    };

    return (
        <>
            <Modal show={load} size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Body>
                    Veuillez patienter.......
                    <Spinner animation="border" variant="success" />
                </Modal.Body>
            </Modal>

            <Formik
                initialValues={{
                    datefact:
                        datefacture ||
                        dateformat(ladate.getMonth() + 1 + '/' + ladate.getDate() + '/' + ladate.getFullYear(), 'yyyy-mm-dd'),
                    fournisseur_id: fournisseur_id,
                    user_id: common.userid,
                    blsids: JSON.stringify(selectedRows),
                    nofact: nofact,
                    sitva: sitva,
                    codeart: JSON.stringify(groupBy(listeSelect)),
                    societe: common.societe,
                    submit: null
                }}
                enableReinitialize
                validationSchema={Yup.object().shape({
                    fournisseur_id: Yup.number().required(common.msg),
                    datefact: Yup.date().required(common.msg)
                })}
                onSubmit={async (values, { setSubmitting }) => {
                    try {
                        setLoad(true);
                        let url = common.ipapi + '/api/entre-facture/store';
                        await Axios.post(url, values)
                            .then((res) => {
                                if (res.data.status === 1) {
                                    setMsg(res.data.msg);
                                    setMsgravity('success');
                                    setIsSave(true);
                                    setLoad(false);
                                    setShowFact(false);
                                    setActualise(!actualise);
                                } else if (res.data.status === 2) {
                                    setMsg(res.data.msg);
                                    setMsgravity('danger');
                                    setIsSave(true);
                                    setLoad(false);
                                } else {
                                    if (res.data.code === 23000) {
                                        setMsg('Ce numéro de bon existe déja');
                                        setMsgravity('danger');
                                        setIsSave(true);
                                        setLoad(false);
                                    } else {
                                        setMsg(res.data.msg);
                                        setMsgravity('danger');
                                        setIsSave(true);
                                        setLoad(false);
                                    }
                                }
                            })
                            .catch((error) => {
                                setIsSave(true);
                                setMsgravity('danger');
                                setLoad(false);
                            });
                        setSubmitting(false);
                    } catch (err) {
                        setMsg('Une erreur à eu lieu');
                        setMsgravity('danger');
                        setIsSave(true);
                        setLoad(false);
                    }
                }}
            >
                {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, setFieldValue, setFieldTouched }) => (
                    <Modal show={show} fullscreen={true} onHide={handleClose}>
                        <div className="content">
                            <Form noValidate onSubmit={handleSubmit}>
                                <Modal.Header>
                                    FACTURATION D'ARTICLES LIVREES
                                    <Backspace onClick={handleClose} color="red" size={30} />
                                </Modal.Header>
                                <Modal.Body>
                                    <div id="lightbody">
                                        <Card>
                                            <CardBody>
                                                <Row>
                                                    <Col md={4}>
                                                        <Form.Group as={Row} className="mb-3">
                                                            <Form.Label column sm={3}>
                                                                Nom fournisseur:
                                                            </Form.Label>
                                                            <Col sm={9}>
                                                                <InputGroup>
                                                                    <Typeahead
                                                                        id="fournisseur_id"
                                                                        multiple={false}
                                                                        labelKey="nomfourn"
                                                                        options={fournisseur}
                                                                        selected={fournisseur.slice(
                                                                            fournisseur.findIndex(
                                                                                (element) => element.id === values.fournisseur_id
                                                                            ),
                                                                            fournisseur.findIndex(
                                                                                (element) => element.id === values.fournisseur_id
                                                                            ) + 1
                                                                        )}
                                                                        disabled={true}
                                                                    />
                                                                </InputGroup>
                                                                {errors.fournisseur_id && <div id="feedback">{errors.fournisseur_id}</div>}
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} className="mb-3">
                                                            <Form.Label column sm={3}>
                                                                N° pièce:
                                                            </Form.Label>
                                                            <Col sm={4}>
                                                                <Form.Control
                                                                    id="nofact"
                                                                    type="text"
                                                                    placeholder="N° de facture"
                                                                    aria-describedby="inputGroupPrepend"
                                                                    size="sm"
                                                                    value={values.nofact}
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    // onChange={(e) => setNobon(e.target.value)}
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} className="mb-3">
                                                            <Form.Label column sm={3}>
                                                                Date facture: <Star color="red" size={10} />
                                                            </Form.Label>
                                                            <Col sm={4}>
                                                                <Form.Control
                                                                    id="date"
                                                                    type="date"
                                                                    placeholder="Date facture"
                                                                    aria-describedby="inputGroupPrepend"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    size="sm"
                                                                    value={values.datefact}
                                                                    // onChange={(e) => setDatesort(e.target.value)}
                                                                />
                                                            </Col>
                                                            {errors.datefact && <div id="feedback">{errors.datefact}</div>}
                                                        </Form.Group>

                                                        <Form.Group as={Row} className="mb-3">
                                                            <Form.Label column sm={4}>
                                                                Application TVA:
                                                            </Form.Label>
                                                            <Col sm={8}>
                                                                <div role="group" aria-labelledby="my-radio-group">
                                                                    <label className="radio">
                                                                        <Field type="radio" name="sitva" value="0" />
                                                                        TVA applicable
                                                                    </label>
                                                                    <label className="radio">
                                                                        <Field type="radio" name="sitva" value="1" />
                                                                        TVA non applicable
                                                                    </label>
                                                                </div>
                                                            </Col>
                                                        </Form.Group>
                                                    </Col>

                                                    <Col md={8}>
                                                        <div>
                                                            <ProductList
                                                                products={listeSelect}
                                                                onChangeProductQuantity={onChangeProductQuantity}
                                                                onRemoveProduct={onRemoveProduct}
                                                                onChangePrestation={onChangePrestation}
                                                                onChangeRemise={onChangeRemise}
                                                                onChangePrix={onChangePrix}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Summary
                                        listeSelect={listeSelect}
                                        sitva={values.sitva}
                                        type_remise={values.type_remise}
                                        remise_main={values.remise_main}
                                    />
                                    <div className="ml-auto">
                                        <ButtonGroup size="sm">
                                            <Button color="secondary" onClick={handleClose}>
                                                <Backspace color="red" size={20} />
                                            </Button>
                                            <Button type="submit" color="warning">
                                                <Save2Fill color="#807f7e" size={20} /> Enregister
                                            </Button>
                                        </ButtonGroup>
                                    </div>
                                </Modal.Footer>
                            </Form>
                        </div>
                    </Modal>
                )}
            </Formik>
        </>
    );
}

export default FactureMultiple;
